import React from 'react';
import { useIntersectionObserver } from '../hooks/useIntersectionObserver.jsx';
export default function HowItWorks() {
  const [containerRef, isVisible] = useIntersectionObserver({
    threshold: 0.15
  });
  return <section id="how-it-works" ref={containerRef} className="py-20 md:py-24 bg-sage-50 relative overflow-hidden" data-name="How It Works Section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className={`text-center max-w-3xl mx-auto mb-16 transition-all duration-800 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <h2 className="text-4xl md:text-5xl font-serif font-bold text-sage-900 mb-4">
            How It Works
          </h2>
          <p className="text-lg md:text-xl text-sage-700 leading-relaxed font-light">
            A simple, clear process to start receiving the specialized support you deserve.
          </p>
        </div>

        {/* 3 Steps Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-10 max-w-6xl mx-auto">
          {/* Step 1 */}
          <div className={`bg-white rounded-2xl p-8 shadow-sm hover:shadow-md transition-all duration-500 flex flex-col justify-between border border-sage-100 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`} style={{
          transitionDelay: '150ms'
        }}>
            <div>
              <div className="w-12 h-12 rounded-xl bg-sage-600 text-white font-serif font-bold text-xl flex items-center justify-center mb-6 shadow-sm">
                1
              </div>
              <h3 className="text-2xl font-serif font-semibold text-sage-900 mb-3">
                Step 1
              </h3>
              <p className="text-gray-700 text-base leading-relaxed mb-6">
                Schedule your free online consultation here.
              </p>
            </div>
            <a href="https://calendly.com/yphilipos/30min" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center w-full px-6 py-3.5 bg-warm-500 hover:bg-warm-600 text-white font-semibold text-sm rounded-full transition-all duration-300 shadow-md hover:shadow-lg transform hover:scale-[1.02] text-center" data-tracking-id="btn-how-it-works-step1">
              <span>Schedule Free Consultation</span>
              <svg className="w-4 h-4 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M14 5l7 7m0 0l-7 7m7-7H3" />
              </svg>
            </a>
          </div>

          {/* Step 2 */}
          <div className={`bg-white rounded-2xl p-8 shadow-sm hover:shadow-md transition-all duration-500 flex flex-col border border-sage-100 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`} style={{
          transitionDelay: '300ms'
        }}>
            <div className="w-12 h-12 rounded-xl bg-sage-600 text-white font-serif font-bold text-xl flex items-center justify-center mb-6 shadow-sm">
              2
            </div>
            <h3 className="text-2xl font-serif font-semibold text-sage-900 mb-3">
              Step 2
            </h3>
            <p className="text-gray-700 text-base leading-relaxed">
              I will call you at the time of your consultation. I’ll answer any questions you have and we will see if we are a good fit. If things don’t work out, I may be able to point you in the right direction.
            </p>
          </div>

          {/* Step 3 */}
          <div className={`bg-white rounded-2xl p-8 shadow-sm hover:shadow-md transition-all duration-500 flex flex-col border border-sage-100 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`} style={{
          transitionDelay: '450ms'
        }}>
            <div className="w-12 h-12 rounded-xl bg-sage-600 text-white font-serif font-bold text-xl flex items-center justify-center mb-6 shadow-sm">
              3
            </div>
            <h3 className="text-2xl font-serif font-semibold text-sage-900 mb-3">
              Step 3
            </h3>
            <p className="text-gray-700 text-base leading-relaxed">
              Get the support and specialized therapy you need. Join me each week remotely or in-person at my office in Redwood City and together we will work toward your goals.
            </p>
          </div>
        </div>
      </div>
    </section>;
}